<template>
    <session class="mobile-page-resetpwd" :class="{ ffen: getLocalLangCode() != 'zh' }">
        <Header />
        <div class="resetpwd-block-wrapper">
            <div class="resetpwd-block">
                <div class="resetpwd-block-l" v-if="step == 1">

                    <div class="resetpwd-block-title">
                        <p class="title">{{ LOCAL('reset_password_title') }}</p>
                        <p class="subtext">{{ LOCAL('reset_password_subtitle') }}</p>
                    </div>
                    <div class="reset_password_method">{{ LOCAL('reset_password_menu') }}</div>

                    <div class="reset_password_method_btn" @click="toInputInfo('email')">{{ LOCAL('reset_password_email') }}</div>

                    <div class="reset_password_method_btn" @click="toInputInfo('mobile')">{{ LOCAL('reset_password_mobile') }}</div>
                </div>
                <div v-if="step == 2" class="reset_password_block">
                    <div class="blocktitle">
                        <div class="backwrap" @click="goBack"><Icon name="back" /><span>{{LOCAL('back')}}</span></div>
                    </div>
                    <div v-if="mtd === 'mobile'" class="reset_password_input">
                        <div class="reset_password_input_area">
                            <FormItemSelect 
                                :options="countryCodeOptions" 
                                :value="countryCodeValue" 
                                :isreset="true"
                                @change="item => getCountryCode(item)"
                            />
                            <input type="tel" v-model="mobile" @input="validateMobile" maxlength="20" onkeypress='return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 43' :placeholder="LOCAL('placeholder_common')">
                        </div>
                        <div v-if="errorAccount" class="res-message" :class="{error_fill: errorAccount}"><span>{{LOCAL('reset_no_account')}}</span></div>
                        <button class="reset_password_via_mobile" :class="{active: isMobile}" @click="findPassword('mobile')" :disabled="!isMobile" >
                            <span :class="{ld: loading}">{{LOCAL('next')}}</span>
                        </button>
                        <div class="loader" v-if="loading"></div>
                    </div>
                    <div v-if="mtd === 'email'" class="reset_password_input">
                        <div class="reset_password_input_area">
                            <div class="label"><span class="required">*</span>{{LOCAL('register_email')}}</div>
                            <input type="email" v-model="email" @input="validateEmail" :placeholder="LOCAL('placeholder_common')">
                        </div>
                        <div v-if="errorAccount" class="res-message" :class="{error_fill: errorAccount}"><span>{{LOCAL('reset_no_account')}}</span></div>
                        <button class="reset_password_via_email" :class="{active: isEmail}" @click="findPassword('email')" :disabled="!isEmail" >
                            <span :class="{ld: loading}">{{LOCAL('next')}}</span>
                        </button>
                        <div class="loader" v-if="loading"></div>
                    </div>
                </div>

            </div>
        </div>
        <Footer />
    </session>
</template>
  
<script setup>
import { ref, onMounted,watchEffect } from 'vue';
import EventBus from '@/assets/eventbus';
import * as Utils from '@/assets/utils';
import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
import Icon from '@/components/icon/index.vue';
    import router from '@/router';
    import Header from '@/mobile/components/header/index.vue';
    import Footer from '@/mobile/components/footer/index.vue';
    import { useRoute } from 'vue-router'
import FormItemSelect from '@/components/formitemselect/index.vue';

// 国家区号
const countryCodeOptions = ref(LOCAL('reset_countryCodeOptions').map(item => ({ label: item, value: item })));
const countryCodeValue = ref('+65');

const route = useRoute();
// 流出步骤
const step = ref(1);  // 1 - 第一步；2 - 第二步
// 入口列表
const mtd = ref('email')
const mobile = ref('')
const email = ref('')
const isMobile = ref(false)
const loading = ref(false)
const errorAccount = ref(false)

const isEmail = ref(false)

const goBack = () => {
    step.value = 1
    email.value = ''
    mobile.value = ''
    errorAccount.value = false
    isMobile.value = false
    isMobile.value = false
}

const toInputInfo = (method) => {
    step.value = 2
    mtd.value = method
}

const validateMobile = () => {
    if (mobile.value.length > 6){
        isMobile.value = true
    } else {
        isMobile.value = false
    }
    errorAccount.value = false
}

const validateEmail = () => {
    if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email.value)) {
        isEmail.value = false
    } else {
        isEmail.value = true
    }
    errorAccount.value = false
}


const findPassword = (methods) => {
    loading.value = true
    if(methods === 'mobile') {
        isMobile.value = false
        setTimeout(() => {
            loading.value = false
            isMobile.value = false
            errorAccount.value = true
        }, 1000);

    } else if(methods === 'email'){
            isEmail.value = false
        setTimeout(() => {
            loading.value = false
            isEmail.value = false
            errorAccount.value = true
        }, 1000);
    }
}

const getCountryCode = (item) => {
    countryCodeValue.value = item[0].value
  }


onMounted(()=> {
    step.value = 1;
    EventBus.on('reset_password_key', (data = null) => {
        if(!data?.flag){step.value = 1;}
    });
    Utils.resetPasswordon(true)
})
  
  </script>

<style scoped lang="less">
    @import "index.less";
</style>
